
export class MailRequest {
    public static readonly TEKLIF_ISTEME_FORMU: string = "teklifIstemeFormu.html";
    public static readonly CARI_BILGI_FORMU: string = "cariBilgiFormu.html";
    public static readonly SIPARIS_FORMU: string = "siparisFormu.html";
    public static readonly YENI_TALEP_FORMU: string = "yeniTalepFormu.html";
    public static readonly SIPARIS_ALINDI_FORMU: string = "siparisTeslimAlindiFormu.html";
    public static readonly CARI_ONAY_FORMU: string = "cariOnayFormu.html";

    toEmail: string;
    subject: string;
    body: string;
    name: string;
    template: string;
    publicAccessKey: string;
    talepNo: string;
    siparisIdler: number[];
    talepId: number;
    irsaliyeId: number;
}
